export default __webpack_public_path__ + "static/flip_bjorn-3e4e9d24f21a2132b0670d85138f3eff.png";